import { createAction, createReducer } from 'redux-starter-kit'
import { createSelector } from 'reselect'
import { filterGroupsWithStandardGroups } from './groupAndAssignUtils'

// Action Types
const OPEN_GROUP_AND_ASSIGN_MODAL = '[groupAndAssign] open modal'
const CLOSE_GROUP_AND_ASSIGN_MODAL = '[groupAndAssign] close modal'
const SET_GROUPS_DATA = '[groupAndAssign] set groups data'
const SET_NOT_GROUPED_STUDENTS = '[groupAndAssign] set not grouped students'

// Action Creators
export const openGroupAndAssignModalAction = createAction(
  OPEN_GROUP_AND_ASSIGN_MODAL
)
export const closeGroupAndAssignModalAction = createAction(
  CLOSE_GROUP_AND_ASSIGN_MODAL
)
export const setGroupsDataAction = createAction(SET_GROUPS_DATA)
export const setNotGroupedStudentsAction = createAction(
  SET_NOT_GROUPED_STUDENTS
)

// Initial State
const initialState = {
  isModalVisible: false,
  groups: [],
  notGroupedStudents: [],
}

// Reducer
const groupAndAssignReducer = createReducer(initialState, {
  [OPEN_GROUP_AND_ASSIGN_MODAL]: (state) => {
    state.isModalVisible = true
  },
  [CLOSE_GROUP_AND_ASSIGN_MODAL]: (state) => {
    state.isModalVisible = false
  },
  [SET_GROUPS_DATA]: (state, action) => {
    state.groups = filterGroupsWithStandardGroups(action.payload || [])
  },
  [SET_NOT_GROUPED_STUDENTS]: (state, action) => {
    state.notGroupedStudents = action.payload ?? []
  },
})

// Selectors
const getGroupAndAssignState = (state) => state.groupAndAssign || initialState

export const getGroupAndAssignModalVisible = createSelector(
  [getGroupAndAssignState],
  (state) => state.isModalVisible
)

export const getGroupsData = createSelector(
  [getGroupAndAssignState],
  (state) => state.groups
)

export const getNotGroupedStudents = createSelector(
  [getGroupAndAssignState],
  (state) => state.notGroupedStudents || []
)

// Export reducer as default
export default groupAndAssignReducer
